export default "__VITE_PUBLIC_ASSET__e1f036fc__"